module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.value))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d7a862e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d7a862e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/badge.vue
// module id = 794
// module chunks = 0